import Toaster from './toaster';

const toaster = new Toaster();

export default toaster;